import { ErrorHandler, Injectable } from '@angular/core';
import { SharedService } from './shared.service';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor(private sharedService: SharedService) {
    super();
  }

  override handleError(error: any) {
    this.sharedService.showErrors(error?.error instanceof Object ? error.error : { error: 'defaultError' });
    super.handleError(error);
  }
}
